module.exports = new __parcel__URL__("adh-logo.81575c1e.png").toString();